import { Base64 } from 'js-base64';

export function getFilterFromParam<T>(defaultValue: T): T {
  const defaultFilter = defaultValue;

  try {
    const urlParams = new URLSearchParams(window.location.search);
    const filterUrlParams = urlParams.get('filter');

    return filterUrlParams ? JSON.parse(Base64.decode(filterUrlParams)) : defaultFilter;
  } catch (err) {
    //
  }

  return defaultFilter;
}
